import React, { } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Empty, Divider, Select } from 'antd';
import { createUseStyles } from 'react-jss'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CollectionServer, IfElse, JSXMap, ObjectToQueryParam, updateInArray, useAuth, useUserContext } from 'fennec-ui'
import { errorCatch, POST } from 'fennec-ui'
import { useNavigation } from 'fennec-ui';
import NovoeMeropriyatiya from '../../forms/NovoeMeropriyatiya'
import "./index.css"
import EventListItem from '../EventListItem';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Option } = Select;

const useStyles = createUseStyles({
    button: {
        marginLeft: "10px"
    }
})

export default function EventBlock(props) {
    const dispatch = useDispatch();
    const user = useUserContext();
    const navigation = useNavigation();
    const auth = useAuth();
    const classes = useStyles();
    const { source, create, strickted, ctx, base, sourceKey } = props;

    const filters = React.useCallback(() => [
        {
            label: "Дата начала",
            name: "nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,

            sorted: "ASC",
            filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
        },
        {   // Тип мероприятия
            label: "Тип мероприятия",
            name: "tipMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Уровень мероприятия
            label: "Уровень мероприятия",
            name: "urovenMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Место проведения
            label: "Место проведения",
            name: "mestoProvedeniya",
            filterType: "group",
            display: (o) => o.name,
            sort: true,
            filter: true
        },
        ...IfElse(create == true, [
            {
                label: "Результаты опубликованы",
                name: "rezultatiOpublikovani",
                sort: true,
                filter: true
            },
            {
                label: "Запрещено публиковать оценки",
                name: "zapreshchenoPublikovatOtsenki",
                sort: true,
                filter: true
            },
        ], [])
    ], []);

    const FilterFromContextFilter = React.useCallback(() => [
        ...ObjectToQueryParam((ctx) ? ctx : {})
    ], [ctx]);

    return (
        <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
            <Divider className={classes.divider} type="horizontal" orientation="left">
                Мероприятия
            </Divider>
            
            {!ctx && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" style={{ padding: "15px 0px" }} />}

            {ctx &&
                <CollectionServer
                    noheader={true}
                    auth={auth}
                    name={"Meropriyatiya"}
                    source={source}
                    contextFilters={FilterFromContextFilter}
                    filters={filters}
                    size={"small"}

                    customRender={(items, {
                        collection,
                        setCollection,
                        setCollectionItem,
                        removeCollectionItem,
                        collectionActions,
                        modelActions,
                        update
                    }) => (<div>
                        {JSXMap(items, (item, idx) => {
                            return (<EventListItem
                                key={idx}
                                event={item}
                                adminButton={create}
                                size={(idx === 0) ? "large" : "medium"}
                                content={() => (create == true) ? <div>
                                    <div>{(item?.rezultatiOpublikovani) ? <span style={{ color: "green", fontSize: "12px" }}>Результаты опубликованы</span> : ""}</div>
                                    <div>{(item?.zapreshchenoPublikovatOtsenki) ? <span style={{ color: "red", fontSize: "12px" }}><i className="fa fa-window-close-o"></i> Запрещено публиковать оценки</span> : ""}</div>
                                </div> : <></>}
                            />)
                        })}
                    </div>)}
                    collectionActions={() => [
                        ...IfElse(
                            (create == true && sourceKey != "admin"), [
                            {
                                // disabled: (context && context.collection && !ctx),
                                auth: auth,
                                form: NovoeMeropriyatiya,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    let o = {
                                        ...values,
                                        nachaloAdministrativnogoKontrolya: values.nachaloSorevnovaniya,
                                        okonchanieAdministrativnogoKontrolya: values.okonchanieSorevnovaniya,
                                        ...((ctx) ? ctx : {})
                                    }
                                    POST(auth, `/api/meropriyatiya/new`, o,
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data));
                                            // close();
                                            navigation(window.location.pathname + "/../" + data.ID);
                                        }, (err) => errorCatch(err, unlock)
                                    );
                                },
                                options: {
                                    initialValues: {},
                                },
                                title: "Новое мероприятие",
                                modal: {
                                    width: "55%",
                                    minWidth: "400px",
                                    title: "Новое мероприятие",
                                },
                                // context: context,
                                sourceKey: sourceKey,
                                base: base,
                                ctx: ctx,
                            }], []),
                    ]}
                />}
        </div>
    );
}
